/* eslint-disable camelcase */
import React from 'react';
import { format } from 'date-fns';
import { useOutletContext } from 'react-router-dom';

import NewsletterConfirmationItem from '../components/NewsletterConfirmationItem';
import Button from '../../../common/Button';
import CampaignItem from '../components/CampaignItem';
import SharePreviewButton from '../../common/SharePreviewButton';

const ConfirmationScreen = () => {
  // eslint-disable-next-line no-unused-vars,max-len,object-curly-newline
  const { pressRelease, pressReleaseMetadata, promoteSites } = useOutletContext();

  const selectedSiteObjects = promoteSites.sitesList
    .filter((site) => pressRelease.crosspost_sites.includes(site.site_id));

  // Generate a CampaignItem for each site in selected Site objects
  const campaignItems = selectedSiteObjects
    .filter((site) => pressRelease.crosspost_sites.includes(site.site_id))
    .map((siteObject) => (
      <CampaignItem
        key={siteObject.site_id}
        siteName={siteObject.site_name}
        siteDomain={siteObject.site_domain}
        pressReleaseUrl={pressRelease.url}
      />
    ));

  // Generate an additional NewsletterConfirmationObject for add-ons
  const topicNewsletterItems = promoteSites.sitesList
    .filter((site) => site.selected)
    .map((site) => (
      site.topic_newsletter_add_on_options
        .filter((newsletter) => newsletter.selected)
        .map(
          (nlObject) => (
            <NewsletterConfirmationItem
              key={nlObject.newsletter_schedule_id}
              siteName={nlObject.site_name}
              topHeader={nlObject.top_header}
              deliveryDays={nlObject.delivery_days}
            />
          ),
        )
    ))
    .flat();

  // null publish_date means it was in the past, i.e. publish immediately
  const publishDate = pressRelease.publish_date ? new Date(pressRelease.publish_date) : Date.now();
  const pressReleasePublishStatus = (new Date() >= publishDate) ? 'PUBLISHED' : 'SCHEDULED';
  const formattedDate = format(publishDate, 'MMMM d, yyyy');
  const currentSite = promoteSites.sitesList
    .find((site) => site.site_id === pressReleaseMetadata.current_site_pk);

  return (
    <>
      <main id="skip-link-target">
        <section className="confirmation">
          <div className="confirmation__background-box" />
          <div className="confirmation__summary-text columns">
            <div className="row">
              <div className="large-9 medium-9">
                {pressReleasePublishStatus === 'SCHEDULED'
                  ? (
                    <h1 className="confirmation__summary-text__header display-heading-03">
                      Your press release has been scheduled for {formattedDate}.
                    </h1>
                  ) : (
                    <h1 className="confirmation__summary-text__header display-heading-03">
                      Your press release has been published.
                    </h1>
                  )}
                <div className="large-8 medium-8">
                  <div className="confirmation__summary-text__title">
                    &ldquo;{pressRelease.title}&rdquo;
                    has been submitted.
                  </div>
                </div>
                <div className="confirmation__summary-text__subheader">
                  We have emailed your receipt to {pressRelease.submitter_email}.
                  Your 7-day visibility report and 21-day campaign wrap-up report will
                  also be sent to this email.
                </div>
                <div className="button-container">
                  {pressReleasePublishStatus === 'SCHEDULED'
                    ? (
                      <SharePreviewButton pressReleasePreviewUrl={pressRelease.preview_url} />
                    ) : (
                      <a
                        className="button button--medium"
                        href={`https://${currentSite?.site_domain}${pressRelease.url}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View live press release
                      </a>
                    )}
                  <Button
                    as="button"
                    onClick={() => window.location.replace(pressRelease.edit_url)}
                    buttonClassName="button--soft"
                  >
                    Edit campaign
                  </Button>
                </div>
              </div>
            </div>
            <div className="confirmation__summary-text__background-extension" />
          </div>
          <div className="row">
            <div className="campaign large-12 columns">
              <div className="campaign__image">
                {/* eslint-disable-next-line global-require */}
                <img src={require('../../../common/img/svg/icon_campaign.svg')} alt="" />
              </div>
              <div className="campaign__info-container">
                <div>
                  <h2 className="campaign__info-container__header">
                    Press release campaign
                  </h2>
                  {pressReleasePublishStatus === 'SCHEDULED'
                    ? (
                      <div className="campaign__info-container__date">Scheduled to publish {formattedDate}, promoted for 21 days</div>
                    ) : (
                      <div className="campaign__info-container__date">Published {formattedDate}, promoted for 21 days</div>
                    )}
                </div>
                <div className="campaign__info-container__items">
                  {campaignItems}
                </div>
              </div>
            </div>
            {topicNewsletterItems.length >= 1
              && (
                <div className="add-on large-12 columns">
                  <div className="add-on__image">
                    {/* eslint-disable-next-line global-require */}
                    <img src={require('../../../common/img/svg/icon_newsletter_add_on.svg')} alt="" />
                  </div>
                  <div className="add-on__info-container">
                    <div>
                      <div className="add-on__info-container__header">
                        Additional newsletter placements
                      </div>
                      <div className="add-on__info-container__subheader">
                        {/* eslint-disable-next-line */}
                        Publication times may vary depending on editorial calendars, inventory, and holidays.
                      </div>
                    </div>
                    <div className="add-on__info-container__items topic">
                      {topicNewsletterItems}
                    </div>
                  </div>
                </div>
              )}
          </div>
        </section>
      </main>
    </>
  );
};

export default ConfirmationScreen;
